import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../common/Loader";
import {
  fetchEvents,
  handleDeleteEvent,
} from "../../redux/actions/grievanceActions1";
import {
  StatCard,
  ContentCard,
  DashboardHeader,
  Icons,
} from "../common/DashboardComponents";
import AddEvent from "../AddEvent/AddEvent";
import UpdateEvent from "../UpdateEvent/UpdateEvent";
import ViewEvent from "../ViewEvent/ViewEvent";

const EventList = () => {
  const dispatch = useDispatch();

  const { events, loading } = useSelector((state) => state.grievances);
  const userData = JSON.parse(localStorage.getItem("user"));
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [eventDetails, setEventDetails] = useState([]);
  const [dateFilter, setDateFilter] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [eventsPerPage] = useState(10);

  // Text trimming lengthx
  const MAX_TITLE_LENGTH = 50;
  const MAX_DESC_LENGTH = 50;

  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  //
  const handleUpdateModal = (event) => {
    setShowUpdateModal(true);
    setEventDetails(event);
  };
  const handleCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  
  const handleViewModal = (event) => {
    setShowViewModal(true);
    setEventDetails(event);
  };
  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };
  
  const openModal = () => {
    setShowModal(true);
  };

  const deleteEvent = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this event? This action cannot be undone."
      )
    ) {
      const res = await dispatch(handleDeleteEvent(id));
      if (res.rCode == 0) {
        alert(res.rMessage || "Event Delete successfully!");
        // resetForm();
        // onClose();
        await dispatch(fetchEvents());
      } else {
        alert(res.rMessage || "Error in Delete Event!");
      }
    }
  };

  useEffect(() => {
    // Simple date parser for DD-MM-YY format  
    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split('-');
      return new Date(2000 + parseInt(year), month - 1, day);
    };

    let result = [...events];

    if (dateFilter !== "all") {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      result = result.filter((event) => {
        const eventDate = parseDate(event.event_date);
        eventDate.setHours(0, 0, 0, 0);

        if (dateFilter === "upcoming") {
          return eventDate >= today;
        } else if (dateFilter === "past") {
          return eventDate < today;
        } else if (dateFilter === "thisMonth") {
          return eventDate.getMonth() === today.getMonth() && 
                 eventDate.getFullYear() === today.getFullYear();
        }
        return true;
      });
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter(
        (event) =>
          (event.title && event.title.toLowerCase().includes(term)) ||
          (event.location && event.location.toLowerCase().includes(term)) ||
          (event.event_desc && event.event_desc.toLowerCase().includes(term)) ||
          (event.important_guests &&
            event.important_guests.toLowerCase().includes(term))
      );
    }

    setFilteredEvents(result);
    setCurrentPage(1);
  }, [events, searchTerm, dateFilter]);

  // Get current events for pagination
  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = filteredEvents.slice(
    indexOfFirstEvent,
    indexOfLastEvent
  );
  const totalPages = Math.ceil(filteredEvents.length / eventsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Text trimming function
  const trimText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  // Format time to a readable format
  const formatTime = (timeString) => {
    if (!timeString) return "";

    try {
      // If time is in HH:MM:SS format
      const [hours, minutes] = timeString.split(":");
      const timeDate = new Date();
      timeDate.setHours(parseInt(hours, 10));
      timeDate.setMinutes(parseInt(minutes, 10));

      return timeDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      return timeString;
    }
  };

  if (loading && events.length === 0) {
    return <Loader message="Loading events..." />;
  }

  // const totalEvents = events.length;
  // const upcomingEvents = events.filter(
  //   (event) => new Date(event.event_date) >= new Date()
  // ).length;
  // const pastEvents = totalEvents - upcomingEvents;
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    return new Date(2000 + parseInt(year), month - 1, day);
  };
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const totalEvents = events.length;
  const upcomingEvents = events.filter(event => {
    const eventDate = parseDate(event.event_date);
    eventDate.setHours(0, 0, 0, 0);
    return eventDate >= today;
  }).length;
  const pastEvents = totalEvents - upcomingEvents;

  return (
    <div className="container-fluid p-4">
      <DashboardHeader title="Events Dashboard" />

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-4 mb-3">
          <StatCard
            title="Total Events"
            value={totalEvents}
            icon={Icons.Calendar}
            color="#4CAF50"
          />
        </div>
        <div className="col-md-4 mb-3">
          <StatCard
            title="Upcoming Events"
            value={upcomingEvents}
            icon={Icons.Event}
            color="#2196F3"
          />
        </div>
        <div className="col-md-4 mb-3">
          <StatCard
            title="Past Events"
            value={pastEvents}
            icon={Icons.History}
            color="#FF9800"
          />
        </div>
      </div>

      {/* Filters and Search */}
      <ContentCard
        title="Search & Filters"
        icon={Icons.Filter}
        className="mb-4"
      >
        <div className="row g-3">
          <div className="col-md-8">
            <div className="input-group">
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search events by title, location, description or guests..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-4">
            <select
              className="form-select"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            >
              <option value="all">All Events</option>
              <option value="upcoming">Upcoming Events</option>
              <option value="past">Past Events</option>
              <option value="thisMonth">This Month</option>
            </select>
          </div>
        </div>
      </ContentCard>

      {/* Events Table/Cards */}
      <ContentCard
        title={`Event List (${filteredEvents.length} events found)`}
        icon={Icons.Event}
        action={
          (userData.role !== 4 && userData.role !== 6 && userData.role !== 7) && (
            <button
              className="btn btn-primary rounded-pill shadow-sm px-3 py-1"
              onClick={() => {
                openModal();
              }}
            >
              <i className="bi bi-plus-lg me-1"></i> Add Event
            </button>
          )
        }
      >
        {/* Mobile-friendly card view for small screens */}
        <div className="d-md-none">
          {currentEvents.length === 0 ? (
            <div className="alert alert-info">No events found</div>
          ) : (
            currentEvents.map((event) => (
              <div key={event.event_id} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6 className="card-title mb-0 fw-bold">
                      {trimText(event.title, MAX_TITLE_LENGTH)}
                    </h6>
                    <div className="btn-group btn-group-sm">
                      <button
                        className="btn btn-outline-success"
                        title="View"
                        onClick={() => handleViewModal(event)}
                      >
                        <i className="bi bi-eye-fill"></i>
                      </button>
                      {userData.role !== 4 && (
                        <button
                          className="btn btn-outline-info"
                          title="Edit"
                          onClick={() => handleUpdateModal(event)}
                        >
                          <i className="bi bi-pencil-fill"></i>
                        </button>
                      )}
                      {userData.role !== 4 && (
                        <button
                          className="btn btn-outline-danger"
                          title="Delete"
                          onClick={() => deleteEvent(event.event_id)}
                        >
                          <i className="bi bi-trash-fill"></i>
                        </button>
                      )}
                    </div>
                  </div>
                  
                  <div className="row g-2 mb-2">
                    <div className="col-6">
                      <small className="text-muted d-block">
                        <i className="bi bi-calendar-event me-1"></i>
                        {event.event_date}
                      </small>
                    </div>
                    <div className="col-6">
                      <small className="text-muted d-block">
                        <i className="bi bi-clock me-1"></i>
                        {formatTime(event.event_from_time)} - {formatTime(event.event_to_time)}
                      </small>
                    </div>
                  </div>
                  
                  <div className="mb-2">
                    <small className="text-muted d-block">
                      <i className="bi bi-geo-alt me-1"></i>
                      {event.location_name}
                    </small>
                  </div>
                  
                  <div className="mb-2">
                    <small className="text-muted">
                      <i className="bi bi-text-paragraph me-1"></i>
                      {trimText(event.event_desc, 80)}
                    </small>
                  </div>
                  
                  {event.important_guests && (
                    <div className="mb-2">
                      <small className="text-muted d-block">
                        <i className="bi bi-people me-1"></i>
                        {trimText(event.important_guests, 60)}
                      </small>
                    </div>
                  )}
                  
                  {event.event_url && (
                    <div className="mb-2">
                      <a
                        href={event.event_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-primary"
                      >
                        <i className="bi bi-box-arrow-up-right me-1"></i>
                        Event Link
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Table view for larger screens */}
        <div className="d-none d-md-block">
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Event Title</th>
                  <th>Date & Time</th>
                  <th>Location</th>
                  <th>Description</th>
                  <th>Important Guests</th>
                  <th>Event Link</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentEvents.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No events found
                    </td>
                  </tr>
                ) : (
                  currentEvents.map((event) => (
                    <tr key={event.event_id}>
                      <td>
                        <strong>
                          {trimText(event.title, MAX_TITLE_LENGTH)}
                        </strong>
                      </td>
                      <td>
                        <div>{event.event_date}</div>
                        <small className="text-muted">
                          {`${formatTime(event.event_from_time)} - ${formatTime(
                            event.event_to_time
                          )}`}
                        </small>
                      </td>
                      <td>{event.location_name}</td>
                      <td>{trimText(event.event_desc, MAX_DESC_LENGTH)}</td>
                      <td>
                        {trimText(event.important_guests, MAX_TITLE_LENGTH)}
                      </td>
                      <td>
                        {event.event_url ? (
                          <a
                            href={event.event_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {event.event_url}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td>
                        {(userData.role !== 4 && userData.role !== 6 && userData.role !== 7) && (
                          <button
                            className="btn btn-sm btn-outline-info me-1"
                            title="Edit"
                            onClick={() => {
                              handleUpdateModal(event);
                            }}
                          >
                            <i className="bi bi-pencil-fill"></i>
                          </button>
                        )}

                        <button
                          className="btn btn-sm btn-outline-success me-1"
                          title="View"
                          onClick={() => {
                            handleViewModal(event);
                          }}
                        >
                          <i className="bi bi-eye-fill"></i>
                        </button>

                        {(userData.role !== 4 && userData.role !== 6 && userData.role !== 7) && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            title="Delete"
                            onClick={() => {
                              deleteEvent(event.event_id);
                            }}
                          >
                            <i className="bi bi-trash-fill"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Modernized Pagination */}
        {filteredEvents.length > 0 && (
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div>
              <small className="text-muted">
                Showing {indexOfFirstEvent + 1} to{" "}
                {Math.min(indexOfLastEvent, filteredEvents.length)} of{" "}
                {filteredEvents.length} events
              </small>
            </div>
            <nav aria-label="Events pagination">
              <ul className="pagination pagination-md justify-content-end mb-0">
                {/* First page button */}
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link rounded-start border-0 shadow-sm"
                    onClick={() => paginate(1)}
                    aria-label="First page"
                  >
                    <i className="bi bi-chevron-double-left"></i>
                  </button>
                </li>

                {/* Previous button */}
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link border-0 shadow-sm"
                    onClick={() => paginate(currentPage - 1)}
                    aria-label="Previous page"
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>

                {/* Page buttons */}
                {[...Array(totalPages).keys()].map((number) => {
                  // Show first page, last page, and 1 page before and after current page
                  if (
                    number + 1 === 1 ||
                    number + 1 === totalPages ||
                    Math.abs(currentPage - (number + 1)) <= 1
                  ) {
                    return (
                      <li
                        key={number + 1}
                        className={`page-item ${
                          currentPage === number + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className={`page-link border-0 shadow-sm ${
                            currentPage === number + 1 ? "bg-primary" : ""
                          }`}
                          onClick={() => paginate(number + 1)}
                        >
                          {number + 1}
                        </button>
                      </li>
                    );
                  }
                  // Add ellipsis if there's a gap
                  else if (
                    (number + 1 === 2 && currentPage > 3) ||
                    (number + 1 === totalPages - 1 &&
                      currentPage < totalPages - 2)
                  ) {
                    return (
                      <li key={number + 1} className="page-item disabled">
                        <span className="page-link border-0">...</span>
                      </li>
                    );
                  }
                  return null;
                })}

                {/* Next button */}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link border-0 shadow-sm"
                    onClick={() => paginate(currentPage + 1)}
                    aria-label="Next page"
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>

                {/* Last page button */}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link rounded-end border-0 shadow-sm"
                    onClick={() => paginate(totalPages)}
                    aria-label="Last page"
                  >
                    <i className="bi bi-chevron-double-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </ContentCard>
      <AddEvent onClose={handleCloseModal} show={showModal} />
      <UpdateEvent
        onClose={handleCloseUpdateModal}
        show={showUpdateModal}
        eventDetails={eventDetails}
      />
      <ViewEvent
        onClose={handleCloseViewModal}
        show={showViewModal}
        eventDetails={eventDetails}
      />
    </div>
  );
};

export default EventList;
